import { render } from "./AdminPicker.vue?vue&type=template&id=4dfe775c"
import script from "./AdminPicker.vue?vue&type=script&lang=js"
export * from "./AdminPicker.vue?vue&type=script&lang=js"

import "./AdminPicker.vue?vue&type=style&index=0&id=4dfe775c&lang=postcss"

import exportComponent from "/var/vhosts/unrisd-frontend/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__